import {validatenull} from './validate'

import {getToken,getStore} from '@/util/store';
import StrUtil from '@/util/str'

/**
 * 设置主题
 */
export const setTheme = (name) => {
  document.body.className = name;
}

/**
 * 获取字典
 */
export const setDic = (dicData, DIC) => {
  return (typeof(dicData) == 'string') ? DIC : dicData
}
/**
 * 设置px
 */
export const setPx = (val, defval) => {
  if (validatenull(val)) {
    val = defval;
  }
  val = val + '';
  if (val.indexOf('%') == -1) {
    val = val + 'px';
  }
  return val;
}
/**
 * 动态获取组件
 */
export const getComponent = (type) => {
  if (type == "select") {
    return "crudSelect";
  } else if (type == "radio") {
    return "crudRadio";
  } else if (type == "checkbox") {
    return "crudCheckbox";
  } else if (type == "date") {
    return "crudDate";
  } else {
    return "crudInput";
  }
};
/**
 * 加密处理
 */
export const encryption = (params) => {
  let {
    data,
    type,
    param,
    key
  } = params;
  let result = JSON.parse(JSON.stringify(data));
  if (type == 'Base64') {
    param.forEach(ele => {
      result[ele] = btoa(result[ele]);
    })
  } else if (type == 'Aes') {
    param.forEach(ele => {
      result[ele] = CryptoJS.AES.encrypt(result[ele], key).toString();
    })

  }
  return result;
};

/**
 * 设置浏览器头部标题
 */
export const setTitle = function (title) {
  title = title ? title : '中国化学法治管理平台';
  window.document.title = title;
};
/**
 * 递归寻找子类的父类
 */

export const findParent = (menu, id) => {
  for (let i = 0; i < menu.length; i++) {
    if (menu[i].children.length != 0) {
      for (let j = 0; j < menu[i].children.length; j++) {
        if (menu[i].children[j].id == id) {
          return menu[i];
        } else {
          if (menu[i].children[j].children.length != 0) {
            return findParent(menu[i].children[j].children, id);
          }
        }
      }
    }
  }
}


/**
 * 转换为menu结构的数据
 */
export function convertToMenu(menuArr) {
  menuArr.map(item=>{
    if(!item.children){
      if (item.url.indexOf("http://") == -1 && item.url.indexOf("https://") == -1) {
        item.code = filterUrl(item.code) + '/index';
      }
    }
  });
  bulidHref(menuArr);
  let result = recursion(menuArr);
  return result;

  function recursion(menuArr){
    if (!menuArr) return [];
    let result = [];
    for (var i = 0; i < menuArr.length; i++) {
      var menuObj = menuArr[i];
      var newMenuObj = {};
      newMenuObj.id = menuObj.id;
      newMenuObj.label = menuObj.name;
      newMenuObj.href = menuObj.code;
      newMenuObj.icon = menuObj.icon;
      newMenuObj.children = recursion(menuObj.children);

      if(menuObj.hiddenFlag != 'Y'){
        result.push(newMenuObj);
      }

    }
    return result;
  }
  /**
   * 组织菜单的href, 父菜单设置为“”，子菜单设置为 parent.href + child.href
   */
  function bulidHref(menuArr) {

    for (let i = 0; i < menuArr.length; i++) {
      var href = filterUrl(menuArr[i].code);
      if (menuArr[i].children.length != 0) {
        //把父节点的url设为空
        menuArr[i].code = "";
        let child = menuArr[i].children;
        for (let j = 0; j < child.length; j++) {
          if (child[j].url.indexOf("http://") == -1 && child[j].url.indexOf("https://") == -1) {
            // 如果不是外部链接, 把子节点的url设为 parentUrl+childUrl
            child[j].code = href.concat(filterUrl(child[j].code));
          }else{
            child[j].code = child[j].url;
            // console.info(child[j].code);
          }
          if (child[j].children.length != 0) {
            bulidHref(child);
          }
        }
      }
    }
  }
  function filterUrl(url) {
    if(!url){
      return "";
    }
    if (url && !url.startsWith("/")) {
      url = "/".concat(url);
    }
    return url;
  }
}
/**
 * 转换为route结构的数据
 */
export function convertToRoute(routesArr) {
  let newRoutes = recursion(routesArr);
  let result = newRoutes.map(item=>{
    if(!item.children || item.children.length == 0){
      let layoutNode = {};
      layoutNode.component = getPromisedComponent('Layout');
      let path = item.path;
      if (path && !path.startsWith("/")) {
        path = "/".concat(path);
      }
      layoutNode.path = path;
      layoutNode.name = item.name;
      layoutNode.meta = item.meta;
      item.path = "index";
      layoutNode.children = [item];
      return layoutNode;
    }else{
      return item
    }
  })
  return result;

  function recursion(routesArr){
    var newRoutes = [];
    if (!routesArr) return [];
    for (var i = 0; i < routesArr.length; i++) {
      var routeObj = routesArr[i];
      var newRouteObj = {};
      newRouteObj.component = getPromisedComponent(routeObj.url);
      newRouteObj.path = filterUrl(routeObj);
      newRouteObj.name = routeObj.name;
      newRouteObj.children = recursion(routeObj.children);
      newRouteObj.meta = routeObj.meta;
      if(!newRouteObj.meta){
        newRouteObj.meta = {appId: routeObj.appId}
      }else{
        newRouteObj.meta.appId = routeObj.appId;
      }
      newRoutes.push(newRouteObj);
    }
    return newRoutes;
  }

  function getPromisedComponent(url) {
    if(StrUtil.isEmpty(url)){
      return () => import('@/components/error-page/404.vue')
    }else if(url == '_BLANK' || url == 'share_b_manage/Blank'){
      return () => import('@/page/index/Blank.vue')
    }else if(url == 'Layout'
      || url == 'layout/Layout'){
      return () => import('@/page/index/index.vue')
    }else{
      return () => import('@/views/' + url + '.vue')
    }

  }

  // 设置顶级节点路由的path首字母为 '/'
  function filterUrl(routeObj) {
    var url = routeObj.code;
    if(routeObj.url == 'Layout'
      || routeObj.url == 'layout/Layout'){
      if (url && !url.startsWith("/")) {
        url = "/".concat(url);
      }
    }
    return url;
  }
}

/**
 * 总体路由处理器
 */
export const resolveUrlPath = (url, name) => {

  let reqUrl = url;
  let token = getToken();
  if (url.indexOf("http://") != -1 || url.indexOf("https://") != -1) {
    reqUrl = `/myiframe/urlPath?src=${reqUrl}?token=${token}&name=${name}`;
  } else {
    reqUrl = `${reqUrl}`;
  }
  return reqUrl;
}
/**
 * 总体路由设置器
 */
export const setUrlPath = ($route) => {
  let value = "";
  if ($route.query.src) {
    value = $route.query.src;
  } else {
    value = $route.path;
  }
  return value;
}
/**
 * 动态插入css
 */

export const loadStyle = url => {
  const link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = url;
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(link);
}
/**
 * 根据字典的value显示label
 */
export const findByvalue = (dic, value) => {
  let result = '';
  if (validatenull(dic)) return value;
  if (typeof (value) == 'string' || typeof (value) == 'number' || typeof (value) == 'boolean') {
    let index = 0;
    index = findArray(dic, value);
    if (index != -1) {
      result = dic[index].label;
    } else {
      result = value;
    }
  } else if (value instanceof Array) {
    result = [];
    let index = 0;
    value.forEach(ele => {
      index = findArray(dic, ele);
      if (index != -1) {
        result.push(dic[index].label);
      } else {
        result.push(value);
      }
    });
    result = result.toString();
  }
  return result;
}
/**
 * 根据字典的value查找对应的index
 */
export const findArray = (dic, value) => {
  for (let i = 0; i < dic.length; i++) {
    if (dic[i].value == value) {
      return i;
      break;
    }
  }
  return -1;
}
/**
 * 生成随机len位数字
 */
export const randomLenNum = (len, date) => {
  let random = '';
  random = Math.ceil(Math.random() * 100000000000000).toString().substr(0, len ? len : 4);
  if (date) random = random + Date.now();
  return random;
}



//扁平数据转化树，为了兼容旧版本系统的方法
export function buildTree(menuList,parent_id='parentId',companyId='companyId'){
  console.time('build');
  let temp = {};
  let ans = [];
  for(let i in menuList){
    temp[menuList[i][companyId]] = menuList[i];
  }
  for(let i in temp){
    if(temp[i][parent_id]&&temp[i][parent_id]!=-1&&temp[i][parent_id]!=0&&temp[temp[i][parent_id]]){
      if(!temp[temp[i][parent_id]].children) {
        temp[temp[i][parent_id]].children = new Array();
      }
      temp[temp[i][parent_id]].children.push(temp[i]);
    } else {
      ans.push(temp[i]);
    }
  }

  console.timeEnd('build');
  return ans;
}
//表格列宽自适应
export function flexColumnWidth (str, tableData, name,flag = 'max'){
  // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
  // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
    str = str + '';
    let columnContent = '';
    let flexWidth = 0;

    if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
      return
    }
    if (!str || !str.length || str.length === 0 || str === undefined) {
      return
    }
     
  
    if (flag === 'equal') {
      // 获取该列中第一个不为空的数据(内容)
        for (let i = 0; i < tableData.length; i++) {
          if (tableData[i][str] !== '' && tableData[i][str].length > 0) {
            // console.log('该列数据[0]:', tableData[0][str])
            columnContent = tableData[i][str]
            break
          }else{
            flexWidth = 130
            console.log('Kong0----')
          }
        }
      } else {
        // 获取该列中最长的数据(内容)
        let index = 0
        for (let i = 0; i < tableData.length; i++) {
          if (tableData[i][str] === null) {
            return
          }
          const now_temp = tableData[i][str] + ''
          const max_temp = tableData[index][str] + ''
          if (now_temp.length > max_temp.length) {
            index = i
          }
        }
        columnContent = tableData[index][str]
      }

        if(columnContent){
          for (const char of columnContent) {
            // console.log(char,`char`)
            if(name === 'infoInviUnitName'){
              flexWidth += 15;
            }
  
            if(name === 'selectPassportNo'){
              flexWidth += 4;
            }
            if(name === 'infoExtIde'){
              flexWidth += 18;
            }
            
          
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
              // 如果是英文字符，为字符分配8像素
              flexWidth += 14;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
              // 如果是中文字符，为字符分配15像素
              flexWidth += 19;
            }else if(char >= '\u0030 '&& char <= '\u0039'){
            // 如果是数字的话
              flexWidth += 16;
            }else {
              // 其他种类字符，为字符分配8像素
              flexWidth += 10;
            }
          }
        }else if(columnContent === null || columnContent === undefined){
          flexWidth = 140
        }
        
      
      if (flexWidth < 80) {
        // 设置最小宽度
        flexWidth = 80
      }   
      if(name === 'leaderName'){
        flexWidth = 120;
      }
      if(name === 'status'){
        flexWidth = 150;
      }
      if(name === 'receiveNo'){
        flexWidth = 200;

      }
      return flexWidth + 'px'
}


// download url
export const downloadUrl = url => {
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = url
  iframe.onload = function () {
    document.body.removeChild(iframe)
  }
  document.body.appendChild(iframe)
}
// download post ajax
export const downloadPost = (config) => {
  const url = config.url
  const data = JSON.parse(config.data)
  const form = document.createElement('form')
  form.action = url
  form.method = 'post'
  form.style.display = 'none'
  Object.keys(data).forEach(key => {
    const input = document.createElement('input')
    input.name = key
    input.value = data[key]
    form.appendChild(input)
  })
  const button = document.createElement('input')
  button.type = 'submit'
  form.appendChild(button)
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}
